import { useTranslation } from 'react-i18next'

type NavBarItemProps = { item: string; selectedItem: string }

export default function NavBarItem({ item, selectedItem }: NavBarItemProps) {
  const { t } = useTranslation()
  return (
    <li className={`mx-1 rounded-full text-sm px-3 py-1 ${item === selectedItem && 'bg-green-700 text-neutral-200'}`}>
      <a href={`#${item}`}>{t(`NavBar.${item}`)}</a>
    </li>
  )
}
